export const constants = {
  errors: {
    already_answered: 'survey already responded'
  },
  survey: {
    options_range_colors: {
      nps_metric: {
        red: 7,
        yellow: 2,
        green: 2
      }
    }
  }

}
